import { Tab, Tabs as MuiTabs } from '@mui/material';
import React from 'react';

interface TabItem {
  label: string;
  value: number;
  isDisabled?: boolean;
}
interface TabsProps {
  tabItems: TabItem[];
  selectedTab: number;
  setSelectedTab: (tab: number) => void;
}

export default function Tabs({ tabItems, selectedTab, setSelectedTab }: TabsProps) {
  return (
    <MuiTabs
      value={selectedTab}
      onChange={(e, val) => setSelectedTab(val)}
      sx={{
        '& .MuiTabs-flexContainer': {
          height: '100%',
          alignItems: 'center',
          gap: 1.5, // Add gap between tabs
        },
        flexShrink: 0,
      }}
    >
      {tabItems.map((tabItem, index) => (
        <Tab
          key={tabItem.label}
          label={tabItem.label}
          disabled={tabItem.isDisabled}
        />
      ))}
    </MuiTabs>
  );
}
